type ShowenSubscribeStorage = {
	expired?: Date
}

export class SubscribeDialog {
	async init() {
		const subscribeDialog = document.querySelector<HTMLDialogElement>(
			"dialog.subscribe-dialog:not(.do-not-show)"
		);
		const shownSubscribeBox = this.createShowenSubscribeStorage(
			JSON.parse(
				window.localStorage.shownSubscribeBox ?? "{}"
			) as Partial<ShowenSubscribeStorage>
		);

		if (
			subscribeDialog &&
			(!shownSubscribeBox.expired || shownSubscribeBox.expired < new Date())
		) {
			const isSubscribed = await fetch(
				"/HomePage/IsSubscribed"
			).then(response => response.text());

			if (isSubscribed.toLowerCase() === "true") {
				return;
			}

			window.setTimeout(function () {
				;(subscribeDialog as any).showModal();

				const expired = new Date(
					new Date().setTime(new Date().getTime() + 24 * 60 * 60 * 1000)
				);
				window.localStorage.shownSubscribeBox = JSON.stringify({
					expired: expired,
				});
			}, 15000);
		}
	}

	private createShowenSubscribeStorage(
		params: Partial<ShowenSubscribeStorage>
	): ShowenSubscribeStorage {
		return {
			expired: params.expired ? new Date(params.expired) : undefined,
		};
	}
}

document.addEventListener("DOMContentLoaded", async () => {
	const subscribeDialog = new SubscribeDialog();
	await subscribeDialog.init();
});
